// extracted by mini-css-extract-plugin
export default {"main":"Card_main__nbMqO","buttons":"Card_buttons__z+KFo","button":"Card_button__FChBP","selected":"Card_selected__WIuso"};